<template>
  <form @submit.prevent="saveForm()">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head flex justify-between">
        <p class="modal-card-title">
          {{ user ? `Edit User: ${ user.firstName } ${ user.lastName }` : 'Add User' }}
        </p>
        <d-switch v-if="user" v-model="userForm.active" class="text-sm">
          Active
        </d-switch>
      </header>
      <section class="modal-card-body">
        <d-field label="First Name">
          <d-input v-model="userForm.firstName" aria-label="first name" required />
        </d-field>
        <d-field label="Last Name">
          <d-input v-model="userForm.lastName" aria-label="last name" required />
        </d-field>
        <d-field label="Email">
          <d-input v-model="userForm.email" aria-label="email" required />
        </d-field>
        <d-field label="Phone Number">
          <d-input v-model="userForm.phoneNumber" aria-label="phone number" />
        </d-field>
        <d-field label="Password" :message="user ? 'Leave blank unless you are changing the password for the user': ''">
          <d-input v-model="userForm.password" aria-label="password" type="password" />
        </d-field>
      </section>
      <footer class="modal-card-foot justify-end">
        <d-btn flat @click="$parent.close()">
          Close
        </d-btn>
        <d-btn :loading="saving" type="submit">
          {{ user ? 'Save Changes' : 'Create User' }}
        </d-btn>
      </footer>
    </div>
  </form>
</template>
<script>
  import axios from 'axios';

  export default {
    props: {
      user: {
        type: Object,
        default: null,
      },
    },

    data() {
      return {
        saving: false,
        userForm: {
          firstName: '',
          lastName: '',
          email: '',
          username: '',
          password: '',
          roles: ['Admin'],
          phoneNumber: '',
        },
      };
    },

    mounted() {
      if (this.user) {
        this.userForm = JSON.parse(JSON.stringify(this.user));
      }
    },

    methods: {
      async saveForm() {
        this.saving = true;
        try {
          if (this.user) {
            await axios.patch(`/api/admin-users/${this.user.id}`, this.userForm);
            this.$toast.open({
              message: 'User has been updated',
              color: 'success',
            });
          } else {
            await axios.post('/api/admin-users', this.userForm);
            this.$toast.open({
              message: 'User has been created',
              color: 'success',
            });
          }
          await this.$parent.events.getUsersPaged();
          this.$parent.close();
        } catch (error) {
          this.processErrors(error, this.userForm);
          this.$toast.open({ message: this.alertMessage[0], color: 'red-500', duration: 4000 });
        } finally {
          this.saving = false;
        }
      },
    },
  };
</script>